import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { deleteVoiceAndTextSnippets } from './voiceSnippetSlice';
// import _ from 'lodash'
import axios from 'axios';
import { config } from '../constants/config'

export const fetchTextVoicePairs = createAsyncThunk(
  'textVoicePairs/fetchTextVoicePairs',
  async ({ userId }) => {
    let query = `${config.GET_API_TEXT_VOICE_SNIPPET_PAIRS}/${userId}`
    const response = await axios.get(query);
    return response.data;
  }
);

export const fetchTextVoicePair = createAsyncThunk(
  'textVoicePairs/fetchTextVoicePair',
  async ({ userId, folderName, fileName, version }) => {
    let query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}`
    if (fileName && version) query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}/${version}`
    else if (fileName) query = `${config.GET_API_TEXT_CLONE_SNIPPETS}/${userId}/${folderName}/${fileName}`
    const response = await axios.get(query);
    return response.data;
  }
);

// export const deleteTextSnippet = createAsyncThunk(
//   'textVoicePairs/deleteTextSnippet',
//   async ({ userId, uuid, s3TextUrl }) => {
//     let s3TextUrlEscaped = encodeURIComponent(s3TextUrl);
//     const response = await axios.delete(`${config.GET_API_TEXT_SNIPPETS}/${userId}/${uuid}/${s3TextUrlEscaped}`);
//     return response.data;
//   }
// );

// export const deleteTextVoicePair = createAsyncThunk(
//   'textVoicePairs/deleteVoiceAndTextSnippets',
//   async ({ userId, uuid }, { getState, dispatch }) => {

//     // manage voice snippet delete
//     const voiceSnippetState = getState().user.voiceSnippets.snippets.snippets;
//     const targetVoiceSnippet = _.find(voiceSnippetState, x => x.uuid === uuid);
//     let s3VoiceUrlEscaped = encodeURIComponent(targetVoiceSnippet.s3Url)

//     // console.log('s3VoiceUrlEscaped', s3VoiceUrlEscaped)
//     const voiceDelResponse = await axios.delete(`${config.GET_API_VOICE_SNIPPETS}/${userId}/${uuid}/${s3VoiceUrlEscaped}`);

//     // manage associated text snippet delete (bound by common uuid values)
//     const textSnippetState = getState().user.textSnippets.snippets.snippets;
//     let targetTextSnippet = _.find(textSnippetState, x => x.uuid === uuid);
//     let s3TextUrlEscaped = encodeURIComponent(targetTextSnippet.s3TextUrl)
//     // console.log('s3TextUrlEscaped', s3TextUrlEscaped)

//     const textDelResponse = await axios.delete(`${config.GET_API_TEXT_SNIPPETS}/${userId}/${targetTextSnippet.uuid}/${s3TextUrlEscaped}`);

//     // return { voiceSnippets: voiceDelResponse.data, textSnippets: textDelResponse.data };
//     return { voiceDelResponse: voiceDelResponse.data, textDelResponse: textDelResponse.data }
//   }
// );


const textVoicePairsSlice = createSlice({
  name: 'textVoicePairs',
  initialState: {
    textVoicePairs: [],
    processedPairs: {},
    status: 'idle',
    addVoicestatus: 'idle',
    deleteVoicestatus: 'idle',
    fetchTextVoicePairsStatus: 'idle',
    deleteTextVoicePairStatus: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTextVoicePairs.pending, (state) => {
        state.fetchTextVoicePairsStatus = 'loading';
        // console.log('fetchVoiceSnippets  pending', 'loading')
      })
      .addCase(fetchTextVoicePairs.fulfilled, (state, action) => {
        state.fetchTextVoicePairsStatus = 'succeeded';
        state.textVoicePairs = action.payload;
      })
      .addCase(fetchTextVoicePairs.rejected, (state, action) => {
        state.fetchTextVoicePairsStatus = 'failed';
        state.error = action.error.message;
      })
    // .addCase(addVoiceSnippet.pending, (state) => {
    //   state.addVoicestatus = 'loading';
    // })
    // .addCase(addVoiceSnippet.fulfilled, (state, action) => {
    //   state.addVoicestatus = 'succeeded';
    //   // state.snippets = action.payload.allVoiceSnippets;
    //   state.snippets = action.payload;

    // })
    // .addCase(addVoiceSnippet.rejected, (state, action) => {
    //   state.addVoicestatus = 'failed';
    //   state.error = action.error.message;
    // })
    // .addCase(deleteVoiceSnippet.pending, (state) => {
    //   state.deleteVoicestatus = 'deleting';
    // })
    // .addCase(deleteVoiceSnippet.fulfilled, (state, action) => {
    //   state.deleteVoicestatus = 'succeeded';
    //   state.snippets = action.payload;
    // })
    // .addCase(deleteVoiceSnippet.rejected, (state, action) => {
    //   state.deleteVoicestatus = 'failed';
    //   state.error = action.error.message;
    // })
    // .addCase(deleteTextVoicePair.pending, (state) => {
    //   state.deleteTextVoicePairStatus = 'deleting';
    // })
    // .addCase(deleteTextVoicePair.fulfilled, (state, action) => {
    //   state.deleteTextVoicePairStatus = 'succeeded';
    //   state.snippets = action.payload.voiceDelResponse;
    // })
    // .addCase(deleteTextVoicePair.rejected, (state, action) => {
    //   state.deleteTextVoicePairStatus = 'failed';
    //   state.error = action.error.message;
    // });
  },
});


export default textVoicePairsSlice.reducer;

export const selectTextVoiceSnippetsStatus = (state) => {
  if (state === undefined) return "idle";
  // console.log('selectTextVoiceSnippetsStatus', state.user.textVoicePairs.fetchTextVoicePairsStatus)
  let textVoicePairStatus = state.user.textVoicePairs.fetchTextVoicePairsStatus;
  return textVoicePairStatus;
}

export const getTextVoicePairs = (state) => {
  const isDefined = (value) => typeof value !== "undefined";

  const areAllTermsDefined = (state) => {
    return isDefined(state) &&
      isDefined(state.user) &&
      isDefined(state.user.textVoicePairs) &&
      state.user.textVoicePairs.fetchTextVoicePairsStatus === "succeeded" &&
      isDefined(state.user.textVoicePairs.textVoicePairs) &&
      isDefined(state.user.textVoicePairs.textVoicePairs.snippetPairs);
  };

  if (!areAllTermsDefined(state)) return [];

  let snipParList = [];
  state.user.textVoicePairs.textVoicePairs.snippetPairs.forEach((x) => {
    const uuid = x.TextSnippet.properties.uuid;  // Assuming each x has a uuid property, adjust accordingly.
    snipParList.push({
      uuid: uuid,
      TextSnippet: x.TextSnippet.properties,
      VoiceSnippet: x.VoiceSnippet.properties
    });
  });

  return snipParList;
};

export const selectPairByUUID = (state, uuid) => {
  const pairs = getTextVoicePairs(state);
  return pairs.find(pair => pair.uuid === uuid);
};